import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';
import { Switch, Router, Route } from 'react-router-dom';
import createMemoryHistory from 'history/createMemoryHistory';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import jaLocal from 'moment/locale/ja';
import MomentUtils from '@date-io/moment';
import {changeScreenSize} from "./actions";
import 'react-datepicker/dist/react-datepicker.css';

import Top from './routes/top';
import MainList from './routes/main-list';



const store = configureStore();
const history = createMemoryHistory();

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#039be5',
			contrastText: '#fff',
		},
		secondary: {
			main: '#ef6c00'
		},
	},
	typography: {
		useNextVariants: true,
	},
});

window.addEventListener('resize', () => {
	store.dispatch(changeScreenSize({
		windowWidth:window.innerWidth,
		windowHeight:window.innerHeight
	}));
});

class LocalizedUtils extends MomentUtils {
	getCalendarHeaderText(date) {
		return date.format("YYYY/MM");
	}
	getDatePickerHeaderText(date) {
		return date.format("MM/DD (ddd)");
	}
}

ReactDOM.render(
	<MuiPickersUtilsProvider utils={LocalizedUtils} local={jaLocal}>
		<MuiThemeProvider theme={theme}>
			<Provider store={store}>
				<Router history={history}>
					<Switch>
						<Route path="/main-list" component={MainList} />
						<Route exact path="/" component={Top} />
					</Switch>
				</Router>
			</Provider>
		</MuiThemeProvider>
	</MuiPickersUtilsProvider>
    ,document.getElementById('reactRoot'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js